export default "__VITE_ASSET__G6JtSY_W__"